import { render } from "./createPublicPersonStepAddress.vue?vue&type=template&id=0ecd3d66&scoped=true"
import script from "./createPublicPersonStepAddress.vue?vue&type=script&lang=js"
export * from "./createPublicPersonStepAddress.vue?vue&type=script&lang=js"

import "./createPublicPersonStepAddress.vue?vue&type=style&index=0&id=0ecd3d66&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecd3d66"]])

export default __exports__